import { useCallback, useEffect, useState } from "react";
import { applyThemeMode, loadThemeMode, type ThemeMode } from "@jkast90/kast-common/theme";

/** Also read by the inline script in index.html; keep the two in step. */
export const THEME_STORAGE_KEY = "salvagers_theme";

export interface Theme {
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
}

/** Light, dark or follow the system (the default), saved per browser. */
export function useTheme(): Theme {
  const [mode, setModeState] = useState<ThemeMode>(() => loadThemeMode(THEME_STORAGE_KEY));

  // Applies the restored choice and, for "system", follows the OS from here on.
  useEffect(() => {
    applyThemeMode(mode);
  }, [mode]);

  const setMode = useCallback((next: ThemeMode) => {
    applyThemeMode(next, THEME_STORAGE_KEY);
    setModeState(next);
  }, []);

  return { mode, setMode };
}
